import { useContext, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import ChevronLeftIcon from './icons/chevronleft.svg?react'
import SidenavIcon from './icons/sidebarleft.svg?react'
import { AppContext } from './AppContext.tsx'
import { useMediaQuery } from '../utils/useMediaQuery.js'

const PageLayout = ({ title, description, rightElement, children }) => {
  const navigate = useNavigate()
  const {
    selectedConversation,
    menuIsOpen,
    onMenuIsOpenChange,
  } = useContext(AppContext)

  const handleBackToChat = useCallback(() => {
    if (selectedConversation?.conversationId) {
      navigate(`/chat/${selectedConversation.conversationId}`)
    } else {
      navigate('/chat')
    }
  }, [navigate, selectedConversation])

  const toggleMenu = () => onMenuIsOpenChange(!menuIsOpen)
  const isMobile = useMediaQuery("(max-width: 768px)")

  return (
    <div className="flex-1 flex flex-col h-full">
      {/* Navigation buttons - full width */}
      <div className="px-spacing-2 pt-spacing-2">
        <div className="flex items-center gap-spacing-2">
          {!menuIsOpen && isMobile && (
            <button 
              className="p-1.5 rounded hover:bg-bg-hover focus:outline-none focus:bg-bg-hover transition-all duration-200"
              onClick={toggleMenu}
              aria-label="Open menu"
            >
              <SidenavIcon className="size-4 cursor-pointer" style={{color:'var(--color-primary)'}}/>
            </button>
          )}
          <button
            onClick={handleBackToChat}
            className="flex items-center gap-spacing-2 px-spacing-2 py-spacing-1 rounded hover:bg-bg-hover text-secondary hover:text-primary transition-colors"
          >
            <ChevronLeftIcon className="size-[14px]" />
            <span className="text-[14px]">Back to chat</span>
          </button>
        </div>
      </div>
      
      {/* Content with max-width */}
      <div className="max-w-[768px] mx-auto px-spacing-6 pb-spacing-8 w-full">
        {/* Header */}
        <div className="mt-spacing-4 mb-spacing-4">
          <h1 className="text-[24px] font-normal mb-spacing-2">{title}</h1>
          {(description || rightElement) && (
            <div className="flex items-center justify-between gap-spacing-4">
              {description && (
                <p className="text-dls-body text-secondary flex-1">{description}</p>
              )}
              {rightElement && (
                <div className="flex-shrink-0">
                  {rightElement}
                </div>
              )}
            </div>
          )}
        </div>
        
        {children}
      </div>
    </div>
  )
}

export default PageLayout
